/** Player-facing oro.* keys that pages call but were missing from the four locale packs. */
export const oroMxGapI18n: Record<string, Record<string, string>> = {
  'es-MX': {
    "oro.announce.aria": "Anuncios de depósitos",
    "oro.common.loading": "Cargando…",
    "oro.deposit.amountInvalid": "Ingresa un monto válido",
    "oro.deposit.amountTitle": "Monto",
    "oro.deposit.bonusTab": "Bonos",
    "oro.deposit.canjeDaily": "Canje diario",
    "oro.deposit.canjeMonthly": "Canje mensual",
    "oro.deposit.canjeWeekly": "Canje semanal",
    "oro.deposit.cashback": "Cashback",
    "oro.deposit.channelLoadFailed": "No se pudieron cargar los canales",
    "oro.deposit.checkoutBlocked": "Pago no disponible por ahora",
    "oro.deposit.checkoutInvalid": "Datos de pago inválidos",
    "oro.deposit.checkoutOpen": "Abrir pago",
    "oro.deposit.checkoutTitle": "Completa tu depósito",
    "oro.deposit.clabeHint": "CLABE: {clabe}",
    "oro.deposit.couponTitle": "Bono +{p}%",
    "oro.deposit.ctaShort": "Depositar {amount}",
    "oro.deposit.extra": "Extra",
    "oro.deposit.insufficient": "Saldo insuficiente",
    "oro.deposit.inviteChest": "Cofre de invitación",
    "oro.deposit.method": "Método de depósito",
    "oro.deposit.needRollover": "Aún debes apostar {amount} para retirar",
    "oro.deposit.noChannel": "No hay canales disponibles",
    "oro.deposit.payPassword": "Contraseña de pago",
    "oro.deposit.payPasswordNeedSet": "Primero configura tu contraseña de pago",
    "oro.deposit.payPasswordPh": "Ingresa 6 dígitos",
    "oro.deposit.pending": "Depósito en proceso",
    "oro.deposit.pendingRollover": "Tienes rollover pendiente",
    "oro.deposit.processing": "Procesando…",
    "oro.deposit.phoneRequired": "Vincula tu número de teléfono para usar este método de pago",
    "oro.deposit.providerUnavailable": "El proveedor no está disponible",
    "oro.deposit.ranking": "Ranking",
    "oro.deposit.redeem": "Canjear",
    "oro.deposit.referenceHint": "Referencia: {reference}",
    "oro.deposit.requestFailed": "No se pudo completar. Inténtalo de nuevo",
    "oro.deposit.rewards": "Recompensas",
    "oro.deposit.signIn": "Check-in",
    "oro.deposit.signInProgress": "Día {current}/{total}",
    "oro.deposit.success": "Depósito exitoso",
    "oro.deposit.wallet": "Billetera",
    "oro.deposit.withdrawAccountIncomplete": "Completa los datos de la cuenta de retiro",
    "oro.deposit.withdrawAccountInvalid": "Cuenta de retiro inválida",
    "oro.deposit.withdrawAmountRange": "El monto está fuera de rango",
    "oro.deposit.withdrawChannelUnavailable": "Canal de retiro no disponible",
    "oro.deposit.withdrawInvalid": "Retiro inválido",
    "oro.deposit.withdrawMin": "Mínimo de retiro: {n}",
    "oro.deposit.withdrawNeedAccount": "Agrega una cuenta de retiro",
    "oro.deposit.withdrawPending": "Retiro en revisión",
    "oro.game.login": "Inicia sesión para jugar",
    "oro.jackpot.congrats": "¡Felicidades {name}! Ganó {amount}",
    "oro.jackpot.reset": "Reinicio",
    "oro.jackpot.taskLoginLabel": "Iniciar sesión",
    "oro.promo.claimPointsInsufficient": "Puntos insuficientes para reclamar",
    "oro.ranking.betRemain": "Apuesta restante",
    "oro.ranking.board.daily": "Diario",
    "oro.ranking.board.monthly": "Mensual",
    "oro.ranking.board.weekly": "Semanal",
    "oro.ranking.boardPoints": "Puntos de ranking",
    "oro.ranking.boostDaily": "Bono diario",
    "oro.ranking.boostLogin": "Bono por inicio",
    "oro.ranking.boostTotal": "Bono total",
    "oro.ranking.boostVip": "Bono VIP",
    "oro.ranking.claim": "Reclamar",
    "oro.ranking.claimFail": "No se pudo reclamar",
    "oro.ranking.claimFailTitle": "Reclamo fallido",
    "oro.ranking.claimSuccess": "Reclamo exitoso",
    "oro.ranking.claimed": "Reclamado",
    "oro.ranking.col.points": "Puntos",
    "oro.ranking.col.rank": "Rango",
    "oro.ranking.col.reward": "Premio",
    "oro.ranking.col.user": "Usuario",
    "oro.ranking.consolation": "premio de consuelo",
    "oro.ranking.dayPoints": "Puntos de hoy",
    "oro.ranking.done": "Completado",
    "oro.ranking.empty": "Aún no hay datos",
    "oro.ranking.jumpMe": "Ir a mi rango",
    "oro.ranking.meCut": "Top {n}",
    "oro.ranking.meGap": "Para entrar",
    "oro.ranking.meListed": "En el ranking",
    "oro.ranking.meMin": "Mínimo {n}",
    "oro.ranking.meNeed": "Faltan {n}",
    "oro.ranking.meNext": "{n} pts al anterior",
    "oro.ranking.meRank": "Mi rango",
    "oro.ranking.meScore": "Mis puntos",
    "oro.ranking.meStatus": "Estado",
    "oro.ranking.meUnlisted": "Sin rango",
    "oro.ranking.meUnreached": "Bajo el mínimo",
    "oro.ranking.pageMeta": "{total} lugares · {pages} páginas",
    "oro.ranking.entryBar": "Barra de entrada",
    "oro.ranking.goBet": "Ir a apostar",
    "oro.ranking.monthPoints": "Puntos del mes",
    "oro.ranking.overCut": "Fuera del top {n}",
    "oro.ranking.pointsCredited": "Puntos acreditados",
    "oro.ranking.prizeFirst": "1.er lugar",
    "oro.ranking.prizeRank": "Lugares {from}-{to}",
    "oro.ranking.redeem": "Canjear",
    "oro.ranking.redeemFail": "No se pudo canjear",
    "oro.ranking.redeemLimit": "Límite de canje alcanzado",
    "oro.ranking.redeemSure": "¿Canjear {from} por {to}?",
    "oro.ranking.rulesBetBody": "Cada {bet} apostados suman {points} puntos",
    "oro.ranking.rulesBetTitle": "Puntos por apuesta",
    "oro.ranking.rulesClaimAfter": "Puedes reclamar {hours} h después del cierre",
    "oro.ranking.rulesDailyBody": "El bono diario se acumula con tu actividad del día",
    "oro.ranking.rulesDailyClose": "El ranking diario cierra a medianoche",
    "oro.ranking.rulesDailyTitle": "Bono diario",
    "oro.ranking.rulesExample": "Ejemplo: apuesta, inicia sesión y sube de VIP para sumar más puntos.",
    "oro.ranking.rulesFormula": "Puntos = base × (1 + bonos)",
    "oro.ranking.rulesFormulaTitle": "Fórmula",
    "oro.ranking.rulesFreeBody": "{stars} estrellas = {points} puntos, hasta {cap} veces al día",
    "oro.ranking.rulesFreeTitle": "Canje de estrellas",
    "oro.ranking.rulesLoginBody": "+{step}% por día seguido, -{miss}% si fallas, tope {max}%",
    "oro.ranking.rulesLoginTitle": "Bono por inicio de sesión",
    "oro.ranking.rulesMinHit": "Si alcanzas el mínimo, entras al ranking",
    "oro.ranking.rulesMinMiss": "Si no alcanzas el mínimo, no entras",
    "oro.ranking.rulesMinNeed": "Se requiere un puntaje mínimo para entrar",
    "oro.ranking.rulesMinTitle": "Puntaje mínimo",
    "oro.ranking.rulesMonthlyClose": "El ranking mensual cierra fin de mes",
    "oro.ranking.rulesRewardTime": "Horario de premios",
    "oro.ranking.rulesTab.point": "Puntos",
    "oro.ranking.rulesTab.rank": "Ranking",
    "oro.ranking.rulesTime": "Horarios",
    "oro.ranking.rulesTitle": "Reglas",
    "oro.ranking.rulesTypes": "Tipos de ranking",
    "oro.ranking.rulesVipBody": "El bono VIP llega hasta {max}%",
    "oro.ranking.rulesVipTitle": "Bono VIP",
    "oro.ranking.rulesWeeklyClose": "El ranking semanal cierra el domingo",
    "oro.ranking.rulesWhat": "Gana puntos con apuestas, inicio de sesión y canjes para subir de rango.",
    "oro.ranking.sectionEarn": "Cómo ganar puntos",
    "oro.ranking.sectionMine": "Mi ranking",
    "oro.ranking.stars": "Estrellas",
    "oro.ranking.tab.panel": "Panel",
    "oro.ranking.tab.premio": "Premio",
    "oro.ranking.tab.rank": "Ranking",
    "oro.ranking.timeLeft": "Tiempo restante",
    "oro.ranking.title": "Ranking",
    "oro.ranking.unavailable": "El ranking no está disponible",
    "oro.ranking.weekPoints": "Puntos de la semana",
    "oro.rec.betAmount": "Monto apostado",
    "oro.rec.loadError": "No se pudieron cargar los datos",
    "oro.rec.loading": "Cargando registros…",
    "oro.rec.retry": "Reintentar",
    "oro.rec.winAmount": "Ganancia",
    "oro.sec.loginChange": "Cambiar",
    "oro.sec.loginConfirm": "Confirmar contraseña",
    "oro.sec.loginHint": "7 a 16 caracteres",
    "oro.sec.loginInvalid": "Contraseña de acceso incorrecta",
    "oro.sec.loginNew": "Nueva contraseña",
    "oro.sec.loginOld": "Contraseña actual",
    "oro.sec.loginRelogin": "Contraseña actualizada. Inicia sesión de nuevo.",
    "oro.sec.mailChange": "Cambiar",
    "oro.sec.mailEmail": "Correo",
    "oro.sec.mailHint": "Ingresa un correo válido",
    "oro.sec.mailInvalid": "Correo inválido o ya en uso",
    "oro.sec.mailLoginPwd": "Contraseña de acceso",
    "oro.sec.codeHint": "Ingresa el código de 6 dígitos",
    "oro.sec.codeInvalid": "Código incorrecto o vencido",
    "oro.sec.codeLabel": "Código",
    "oro.sec.mailTaken": "Este correo ya está en uso",
    "oro.sec.phoneDesc": "Vincula tu teléfono para iniciar sesión y verificar tu cuenta.",
    "oro.sec.phoneHint": "Ingresa 10 dígitos",
    "oro.sec.phoneLabel": "Teléfono",
    "oro.sec.phoneSame": "Este teléfono ya está vinculado",
    "oro.sec.phoneTaken": "Este teléfono ya está en uso",
    "oro.sec.phoneTitle": "Teléfono",
    "oro.sec.rateLimited": "Demasiados intentos. Espera un momento.",
    "oro.sec.sendCode": "Enviar",
    "oro.sec.sendFailed": "No se pudo enviar el código",
    "oro.sec.payChange": "Cambiar",
    "oro.sec.payConfirm": "Confirmar contraseña de pago",
    "oro.sec.payDesc": "Configura una contraseña de 6 dígitos antes de retirar.",
    "oro.sec.payHint": "Ingresa 6 dígitos",
    "oro.sec.payInvalid": "Contraseña de pago incorrecta",
    "oro.sec.payMismatch": "Las contraseñas no coinciden",
    "oro.sec.payNew": "Nueva contraseña de pago",
    "oro.sec.payOld": "Contraseña actual",
    "oro.sec.paySet": "Configurar",
    "oro.sec.payTitle": "Contraseña de pago",
    "oro.team.calcRatePct": "Tasa %",
    "oro.team.howReferralNotes": "Notas de referidos",
    "oro.team.ruleRebate": "El reembolso se calcula según el nivel del equipo.",
    "oro.team.ruleSize": "El tamaño del equipo afecta tu nivel.",
    "oro.team.ruleVolume": "El volumen de apuestas del equipo afecta tu comisión.",
  },
  'en-US': {
    "oro.announce.aria": "Deposit announcements",
    "oro.common.loading": "Loading…",
    "oro.deposit.amountInvalid": "Enter a valid amount",
    "oro.deposit.amountTitle": "Amount",
    "oro.deposit.bonusTab": "Bonus",
    "oro.deposit.canjeDaily": "Daily rebate",
    "oro.deposit.canjeMonthly": "Monthly rebate",
    "oro.deposit.canjeWeekly": "Weekly rebate",
    "oro.deposit.cashback": "Cashback",
    "oro.deposit.channelLoadFailed": "Could not load channels",
    "oro.deposit.checkoutBlocked": "Checkout is unavailable right now",
    "oro.deposit.checkoutInvalid": "Invalid checkout data",
    "oro.deposit.checkoutOpen": "Open checkout",
    "oro.deposit.checkoutTitle": "Complete your deposit",
    "oro.deposit.clabeHint": "CLABE: {clabe}",
    "oro.deposit.couponTitle": "Bonus +{p}%",
    "oro.deposit.ctaShort": "Deposit {amount}",
    "oro.deposit.extra": "Extra",
    "oro.deposit.insufficient": "Insufficient balance",
    "oro.deposit.inviteChest": "Invite chest",
    "oro.deposit.method": "Deposit method",
    "oro.deposit.needRollover": "You still need to wager {amount} to withdraw",
    "oro.deposit.noChannel": "No channels available",
    "oro.deposit.payPassword": "Payment password",
    "oro.deposit.payPasswordNeedSet": "Set your payment password first",
    "oro.deposit.payPasswordPh": "Enter 6 digits",
    "oro.deposit.pending": "Deposit pending",
    "oro.deposit.pendingRollover": "You have pending rollover",
    "oro.deposit.processing": "Processing…",
    "oro.deposit.phoneRequired": "Bind your phone number to use this payment method",
    "oro.deposit.providerUnavailable": "Payment provider unavailable",
    "oro.deposit.ranking": "Ranking",
    "oro.deposit.redeem": "Redeem",
    "oro.deposit.referenceHint": "Reference: {reference}",
    "oro.deposit.requestFailed": "Request failed. Please try again",
    "oro.deposit.rewards": "Rewards",
    "oro.deposit.signIn": "Check-in",
    "oro.deposit.signInProgress": "Day {current}/{total}",
    "oro.deposit.success": "Deposit successful",
    "oro.deposit.wallet": "Wallet",
    "oro.deposit.withdrawAccountIncomplete": "Complete the withdrawal account details",
    "oro.deposit.withdrawAccountInvalid": "Invalid withdrawal account",
    "oro.deposit.withdrawAmountRange": "Amount is out of range",
    "oro.deposit.withdrawChannelUnavailable": "Withdrawal channel unavailable",
    "oro.deposit.withdrawInvalid": "Invalid withdrawal",
    "oro.deposit.withdrawMin": "Minimum withdrawal: {n}",
    "oro.deposit.withdrawNeedAccount": "Add a withdrawal account",
    "oro.deposit.withdrawPending": "Withdrawal pending",
    "oro.game.login": "Sign in to play",
    "oro.jackpot.congrats": "Congrats {name}! Won {amount}",
    "oro.jackpot.reset": "Reset",
    "oro.jackpot.taskLoginLabel": "Sign in",
    "oro.promo.claimPointsInsufficient": "Not enough points to claim",
    "oro.ranking.betRemain": "Remaining wager",
    "oro.ranking.board.daily": "Daily",
    "oro.ranking.board.monthly": "Monthly",
    "oro.ranking.board.weekly": "Weekly",
    "oro.ranking.boardPoints": "Ranking points",
    "oro.ranking.boostDaily": "Daily boost",
    "oro.ranking.boostLogin": "Login boost",
    "oro.ranking.boostTotal": "Total boost",
    "oro.ranking.boostVip": "VIP boost",
    "oro.ranking.claim": "Claim",
    "oro.ranking.claimFail": "Could not claim",
    "oro.ranking.claimFailTitle": "Claim failed",
    "oro.ranking.claimSuccess": "Claimed successfully",
    "oro.ranking.claimed": "Claimed",
    "oro.ranking.col.points": "Points",
    "oro.ranking.col.rank": "Rank",
    "oro.ranking.col.reward": "Reward",
    "oro.ranking.col.user": "User",
    "oro.ranking.consolation": "consolation prize",
    "oro.ranking.dayPoints": "Today's points",
    "oro.ranking.done": "Done",
    "oro.ranking.empty": "No data yet",
    "oro.ranking.jumpMe": "Jump to my rank",
    "oro.ranking.meCut": "Top {n}",
    "oro.ranking.meGap": "To enter",
    "oro.ranking.meListed": "On the board",
    "oro.ranking.meMin": "Need {n}",
    "oro.ranking.meNeed": "Need {n}",
    "oro.ranking.meNext": "{n} pts to next",
    "oro.ranking.meRank": "My rank",
    "oro.ranking.meScore": "My points",
    "oro.ranking.meStatus": "Status",
    "oro.ranking.meUnlisted": "Unranked",
    "oro.ranking.meUnreached": "Below cutoff",
    "oro.ranking.pageMeta": "{total} ranks · {pages} pages",
    "oro.ranking.entryBar": "Entry progress",
    "oro.ranking.goBet": "Go bet",
    "oro.ranking.monthPoints": "This month's points",
    "oro.ranking.overCut": "Outside top {n}",
    "oro.ranking.pointsCredited": "Points credited",
    "oro.ranking.prizeFirst": "1st place",
    "oro.ranking.prizeRank": "Ranks {from}-{to}",
    "oro.ranking.redeem": "Redeem",
    "oro.ranking.redeemFail": "Could not redeem",
    "oro.ranking.redeemLimit": "Redeem limit reached",
    "oro.ranking.redeemSure": "Redeem {from} for {to}?",
    "oro.ranking.rulesBetBody": "Every {bet} wagered adds {points} points",
    "oro.ranking.rulesBetTitle": "Points from bets",
    "oro.ranking.rulesClaimAfter": "Claim opens {hours} h after close",
    "oro.ranking.rulesDailyBody": "Daily boost grows with today's activity",
    "oro.ranking.rulesDailyClose": "Daily ranking closes at midnight",
    "oro.ranking.rulesDailyTitle": "Daily boost",
    "oro.ranking.rulesExample": "Example: bet, sign in, and raise VIP to earn more points.",
    "oro.ranking.rulesFormula": "Points = base × (1 + boosts)",
    "oro.ranking.rulesFormulaTitle": "Formula",
    "oro.ranking.rulesFreeBody": "{stars} stars = {points} points, up to {cap} times a day",
    "oro.ranking.rulesFreeTitle": "Star redeem",
    "oro.ranking.rulesLoginBody": "+{step}% per consecutive day, -{miss}% if missed, cap {max}%",
    "oro.ranking.rulesLoginTitle": "Login boost",
    "oro.ranking.rulesMinHit": "Reach the minimum to enter the ranking",
    "oro.ranking.rulesMinMiss": "Below the minimum you stay off the board",
    "oro.ranking.rulesMinNeed": "A minimum score is required to enter",
    "oro.ranking.rulesMinTitle": "Minimum score",
    "oro.ranking.rulesMonthlyClose": "Monthly ranking closes at month end",
    "oro.ranking.rulesRewardTime": "Reward schedule",
    "oro.ranking.rulesTab.point": "Points",
    "oro.ranking.rulesTab.rank": "Ranking",
    "oro.ranking.rulesTime": "Schedule",
    "oro.ranking.rulesTitle": "Rules",
    "oro.ranking.rulesTypes": "Ranking types",
    "oro.ranking.rulesVipBody": "VIP boost is capped at {max}%",
    "oro.ranking.rulesVipTitle": "VIP boost",
    "oro.ranking.rulesWeeklyClose": "Weekly ranking closes on Sunday",
    "oro.ranking.rulesWhat": "Earn points from bets, logins, and redeems to climb the board.",
    "oro.ranking.sectionEarn": "How to earn points",
    "oro.ranking.sectionMine": "My ranking",
    "oro.ranking.stars": "Stars",
    "oro.ranking.tab.panel": "Panel",
    "oro.ranking.tab.premio": "Prize",
    "oro.ranking.tab.rank": "Ranking",
    "oro.ranking.timeLeft": "Time left",
    "oro.ranking.title": "Ranking",
    "oro.ranking.unavailable": "Ranking is unavailable",
    "oro.ranking.weekPoints": "This week's points",
    "oro.rec.betAmount": "Bet amount",
    "oro.rec.loadError": "Could not load records",
    "oro.rec.loading": "Loading records…",
    "oro.rec.retry": "Retry",
    "oro.rec.winAmount": "Win amount",
    "oro.sec.loginChange": "Change",
    "oro.sec.loginConfirm": "Confirm password",
    "oro.sec.loginHint": "7 to 16 characters",
    "oro.sec.loginInvalid": "Incorrect login password",
    "oro.sec.loginNew": "New password",
    "oro.sec.loginOld": "Current password",
    "oro.sec.loginRelogin": "Password updated. Please sign in again.",
    "oro.sec.mailChange": "Change",
    "oro.sec.mailEmail": "Email",
    "oro.sec.mailHint": "Enter a valid email",
    "oro.sec.mailInvalid": "Invalid or unavailable email",
    "oro.sec.mailLoginPwd": "Login password",
    "oro.sec.codeHint": "Enter the 6-digit code",
    "oro.sec.codeInvalid": "Incorrect or expired code",
    "oro.sec.codeLabel": "Code",
    "oro.sec.mailTaken": "This email is already in use",
    "oro.sec.phoneDesc": "Link your phone for login and account security.",
    "oro.sec.phoneHint": "Enter 10 digits",
    "oro.sec.phoneLabel": "Phone",
    "oro.sec.phoneSame": "This phone is already linked",
    "oro.sec.phoneTaken": "This phone is already in use",
    "oro.sec.phoneTitle": "Phone",
    "oro.sec.rateLimited": "Too many attempts. Wait a moment.",
    "oro.sec.sendCode": "Send",
    "oro.sec.sendFailed": "Could not send the code",
    "oro.sec.payChange": "Change",
    "oro.sec.payConfirm": "Confirm payment password",
    "oro.sec.payDesc": "Set a 6-digit password before withdrawing.",
    "oro.sec.payHint": "Enter 6 digits",
    "oro.sec.payInvalid": "Incorrect payment password",
    "oro.sec.payMismatch": "Passwords do not match",
    "oro.sec.payNew": "New payment password",
    "oro.sec.payOld": "Current password",
    "oro.sec.paySet": "Set",
    "oro.sec.payTitle": "Payment password",
    "oro.team.calcRatePct": "Rate %",
    "oro.team.howReferralNotes": "Referral notes",
    "oro.team.ruleRebate": "Rebate is calculated by team level.",
    "oro.team.ruleSize": "Team size affects your level.",
    "oro.team.ruleVolume": "Team betting volume affects commission.",
  },
  'zh-CN': {
    "oro.announce.aria": "存款公告",
    "oro.common.loading": "加载中…",
    "oro.deposit.amountInvalid": "请输入有效金额",
    "oro.deposit.amountTitle": "金额",
    "oro.deposit.bonusTab": "优惠",
    "oro.deposit.canjeDaily": "每日返水",
    "oro.deposit.canjeMonthly": "每月返水",
    "oro.deposit.canjeWeekly": "每周返水",
    "oro.deposit.cashback": "亏损返还",
    "oro.deposit.channelLoadFailed": "通道加载失败",
    "oro.deposit.checkoutBlocked": "暂时无法打开支付",
    "oro.deposit.checkoutInvalid": "支付信息无效",
    "oro.deposit.checkoutOpen": "打开支付",
    "oro.deposit.checkoutTitle": "完成充值",
    "oro.deposit.clabeHint": "CLABE：{clabe}",
    "oro.deposit.couponTitle": "优惠 +{p}%",
    "oro.deposit.ctaShort": "充值 {amount}",
    "oro.deposit.extra": "额外",
    "oro.deposit.insufficient": "余额不足",
    "oro.deposit.inviteChest": "邀请宝箱",
    "oro.deposit.method": "充值方式",
    "oro.deposit.needRollover": "还需完成流水 {amount} 才能提现",
    "oro.deposit.noChannel": "暂无可用通道",
    "oro.deposit.payPassword": "支付密码",
    "oro.deposit.payPasswordNeedSet": "请先设置支付密码",
    "oro.deposit.payPasswordPh": "请输入6位数字",
    "oro.deposit.pending": "充值处理中",
    "oro.deposit.pendingRollover": "仍有未完成流水",
    "oro.deposit.processing": "处理中…",
    "oro.deposit.phoneRequired": "请先绑定手机号后再使用该支付方式",
    "oro.deposit.providerUnavailable": "支付通道暂不可用",
    "oro.deposit.ranking": "排行榜",
    "oro.deposit.redeem": "领取",
    "oro.deposit.referenceHint": "参考号：{reference}",
    "oro.deposit.requestFailed": "请求失败，请稍后再试",
    "oro.deposit.rewards": "奖励",
    "oro.deposit.signIn": "签到",
    "oro.deposit.signInProgress": "第 {current}/{total} 天",
    "oro.deposit.success": "充值成功",
    "oro.deposit.wallet": "钱包",
    "oro.deposit.withdrawAccountIncomplete": "提现账户信息不完整",
    "oro.deposit.withdrawAccountInvalid": "提现账户无效",
    "oro.deposit.withdrawAmountRange": "提现金额超出范围",
    "oro.deposit.withdrawChannelUnavailable": "提现通道暂不可用",
    "oro.deposit.withdrawInvalid": "提现请求无效",
    "oro.deposit.withdrawMin": "最低提现 {n}",
    "oro.deposit.withdrawNeedAccount": "请先添加提现账户",
    "oro.deposit.withdrawPending": "提现处理中",
    "oro.game.login": "登录后开始游戏",
    "oro.jackpot.congrats": "恭喜 {name} 获得 {amount}",
    "oro.jackpot.reset": "重置",
    "oro.jackpot.taskLoginLabel": "登录",
    "oro.promo.claimPointsInsufficient": "积分不足，无法领取",
    "oro.ranking.betRemain": "剩余投注",
    "oro.ranking.board.daily": "日榜",
    "oro.ranking.board.monthly": "月榜",
    "oro.ranking.board.weekly": "周榜",
    "oro.ranking.boardPoints": "榜单积分",
    "oro.ranking.boostDaily": "每日加成",
    "oro.ranking.boostLogin": "登录加成",
    "oro.ranking.boostTotal": "总加成",
    "oro.ranking.boostVip": "VIP 加成",
    "oro.ranking.claim": "领取",
    "oro.ranking.claimFail": "领取失败",
    "oro.ranking.claimFailTitle": "领取未成功",
    "oro.ranking.claimSuccess": "领取成功",
    "oro.ranking.claimed": "已领取",
    "oro.ranking.col.points": "积分",
    "oro.ranking.col.rank": "名次",
    "oro.ranking.col.reward": "奖励",
    "oro.ranking.col.user": "用户",
    "oro.ranking.consolation": "安慰奖",
    "oro.ranking.dayPoints": "今日积分",
    "oro.ranking.done": "已完成",
    "oro.ranking.empty": "暂无数据",
    "oro.ranking.jumpMe": "跳到我的排名",
    "oro.ranking.meCut": "前 {n}",
    "oro.ranking.meGap": "距离上榜",
    "oro.ranking.meListed": "已上榜",
    "oro.ranking.meMin": "门槛 {n}",
    "oro.ranking.meNeed": "还需 {n}",
    "oro.ranking.meNext": "距上一名 {n} 分",
    "oro.ranking.meRank": "我的排名",
    "oro.ranking.meScore": "我的积分",
    "oro.ranking.meStatus": "上榜状态",
    "oro.ranking.meUnlisted": "未上榜",
    "oro.ranking.meUnreached": "未达门槛",
    "oro.ranking.pageMeta": "共 {total} 名 · {pages} 页",
    "oro.ranking.entryBar": "上榜进度",
    "oro.ranking.goBet": "去投注",
    "oro.ranking.monthPoints": "本月积分",
    "oro.ranking.overCut": "未进入前 {n}",
    "oro.ranking.pointsCredited": "积分已到账",
    "oro.ranking.prizeFirst": "第 1 名",
    "oro.ranking.prizeRank": "第 {from}-{to} 名",
    "oro.ranking.redeem": "兑换",
    "oro.ranking.redeemFail": "兑换失败",
    "oro.ranking.redeemLimit": "已达兑换上限",
    "oro.ranking.redeemSure": "确认将 {from} 兑换为 {to}？",
    "oro.ranking.rulesBetBody": "每投注 {bet} 获得 {points} 积分",
    "oro.ranking.rulesBetTitle": "投注积分",
    "oro.ranking.rulesClaimAfter": "结算 {hours} 小时后可领取",
    "oro.ranking.rulesDailyBody": "每日加成随当日活跃累积",
    "oro.ranking.rulesDailyClose": "日榜于当天结束时结算",
    "oro.ranking.rulesDailyTitle": "每日加成说明",
    "oro.ranking.rulesExample": "示例：投注、登录并提升 VIP 可获得更多积分。",
    "oro.ranking.rulesFormula": "积分 = 基础分 ×（1 + 加成）",
    "oro.ranking.rulesFormulaTitle": "计算公式",
    "oro.ranking.rulesFreeBody": "{stars} 星星可兑 {points} 积分，每日最多 {cap} 次",
    "oro.ranking.rulesFreeTitle": "星星兑换",
    "oro.ranking.rulesLoginBody": "连续登录每天 +{step}%，中断 -{miss}%，上限 {max}%",
    "oro.ranking.rulesLoginTitle": "登录加成说明",
    "oro.ranking.rulesMinHit": "达到最低要求即可上榜",
    "oro.ranking.rulesMinMiss": "未达最低要求不上榜",
    "oro.ranking.rulesMinNeed": "上榜需达到最低积分",
    "oro.ranking.rulesMinTitle": "最低上榜分",
    "oro.ranking.rulesMonthlyClose": "月榜于月末结算",
    "oro.ranking.rulesRewardTime": "发奖时间",
    "oro.ranking.rulesTab.point": "积分规则",
    "oro.ranking.rulesTab.rank": "榜单规则",
    "oro.ranking.rulesTime": "结算时间",
    "oro.ranking.rulesTitle": "活动规则",
    "oro.ranking.rulesTypes": "榜单类型",
    "oro.ranking.rulesVipBody": "VIP 加成最高 {max}%",
    "oro.ranking.rulesVipTitle": "VIP 加成说明",
    "oro.ranking.rulesWeeklyClose": "周榜于周日结算",
    "oro.ranking.rulesWhat": "通过投注、登录和兑换获得积分并提升名次。",
    "oro.ranking.sectionEarn": "如何获得积分",
    "oro.ranking.sectionMine": "我的排名",
    "oro.ranking.stars": "星星",
    "oro.ranking.tab.panel": "面板",
    "oro.ranking.tab.premio": "奖励",
    "oro.ranking.tab.rank": "排行",
    "oro.ranking.timeLeft": "剩余时间",
    "oro.ranking.title": "排行榜",
    "oro.ranking.unavailable": "排行榜暂不可用",
    "oro.ranking.weekPoints": "本周积分",
    "oro.rec.betAmount": "投注额",
    "oro.rec.loadError": "记录加载失败",
    "oro.rec.loading": "正在加载记录…",
    "oro.rec.retry": "重试",
    "oro.rec.winAmount": "赢额",
    "oro.sec.loginChange": "修改",
    "oro.sec.loginConfirm": "确认登录密码",
    "oro.sec.loginHint": "7 到 16 个字符",
    "oro.sec.loginInvalid": "登录密码不正确",
    "oro.sec.loginNew": "新登录密码",
    "oro.sec.loginOld": "原登录密码",
    "oro.sec.loginRelogin": "密码已更新，请重新登录。",
    "oro.sec.mailChange": "修改",
    "oro.sec.mailEmail": "邮箱",
    "oro.sec.mailHint": "请输入有效邮箱",
    "oro.sec.mailInvalid": "邮箱无效或不可用",
    "oro.sec.mailLoginPwd": "登录密码",
    "oro.sec.codeHint": "请输入6位验证码",
    "oro.sec.codeInvalid": "验证码错误或已过期",
    "oro.sec.codeLabel": "验证码",
    "oro.sec.mailTaken": "该邮箱已被使用",
    "oro.sec.phoneDesc": "绑定手机号以用于登录和安全验证。",
    "oro.sec.phoneHint": "请输入10位手机号",
    "oro.sec.phoneLabel": "手机号",
    "oro.sec.phoneSame": "该手机号已是当前绑定",
    "oro.sec.phoneTaken": "该手机号已被使用",
    "oro.sec.phoneTitle": "手机号",
    "oro.sec.rateLimited": "操作太频繁，请稍后再试",
    "oro.sec.sendCode": "获取验证码",
    "oro.sec.sendFailed": "验证码发送失败",
    "oro.sec.payChange": "修改",
    "oro.sec.payConfirm": "确认支付密码",
    "oro.sec.payDesc": "提现前请设置6位数字支付密码。",
    "oro.sec.payHint": "请输入6位数字",
    "oro.sec.payInvalid": "支付密码不正确",
    "oro.sec.payMismatch": "两次密码不一致",
    "oro.sec.payNew": "新支付密码",
    "oro.sec.payOld": "原支付密码",
    "oro.sec.paySet": "设置",
    "oro.sec.payTitle": "设置支付密码。",
    "oro.team.calcRatePct": "比例 %",
    "oro.team.howReferralNotes": "推荐说明",
    "oro.team.ruleRebate": "返利按团队等级计算。",
    "oro.team.ruleSize": "团队人数影响等级。",
    "oro.team.ruleVolume": "团队流水影响佣金。",
  },
  'zh-TW': {
    "oro.announce.aria": "存款公告",
    "oro.common.loading": "載入中…",
    "oro.deposit.amountInvalid": "請輸入有效金額",
    "oro.deposit.amountTitle": "金額",
    "oro.deposit.bonusTab": "優惠",
    "oro.deposit.canjeDaily": "每日返水",
    "oro.deposit.canjeMonthly": "每月返水",
    "oro.deposit.canjeWeekly": "每週返水",
    "oro.deposit.cashback": "虧損返還",
    "oro.deposit.channelLoadFailed": "通道載入失敗",
    "oro.deposit.checkoutBlocked": "暫時無法打開支付",
    "oro.deposit.checkoutInvalid": "支付資訊無效",
    "oro.deposit.checkoutOpen": "打開支付",
    "oro.deposit.checkoutTitle": "完成儲值",
    "oro.deposit.clabeHint": "CLABE：{clabe}",
    "oro.deposit.couponTitle": "優惠 +{p}%",
    "oro.deposit.ctaShort": "儲值 {amount}",
    "oro.deposit.extra": "額外",
    "oro.deposit.insufficient": "餘額不足",
    "oro.deposit.inviteChest": "邀請寶箱",
    "oro.deposit.method": "儲值方式",
    "oro.deposit.needRollover": "還需完成流水 {amount} 才能提現",
    "oro.deposit.noChannel": "暫無可用通道",
    "oro.deposit.payPassword": "支付密碼",
    "oro.deposit.payPasswordNeedSet": "請先設定支付密碼",
    "oro.deposit.payPasswordPh": "請輸入6位數字",
    "oro.deposit.pending": "儲值處理中",
    "oro.deposit.pendingRollover": "仍有未完成流水",
    "oro.deposit.processing": "處理中…",
    "oro.deposit.phoneRequired": "請先綁定手機號後再使用該支付方式",
    "oro.deposit.providerUnavailable": "支付通道暫不可用",
    "oro.deposit.ranking": "排行榜",
    "oro.deposit.redeem": "領取",
    "oro.deposit.referenceHint": "參考號：{reference}",
    "oro.deposit.requestFailed": "請求失敗，請稍後再試",
    "oro.deposit.rewards": "獎勵",
    "oro.deposit.signIn": "簽到",
    "oro.deposit.signInProgress": "第 {current}/{total} 天",
    "oro.deposit.success": "儲值成功",
    "oro.deposit.wallet": "錢包",
    "oro.deposit.withdrawAccountIncomplete": "提現帳戶資訊不完整",
    "oro.deposit.withdrawAccountInvalid": "提現帳戶無效",
    "oro.deposit.withdrawAmountRange": "提現金額超出範圍",
    "oro.deposit.withdrawChannelUnavailable": "提現通道暫不可用",
    "oro.deposit.withdrawInvalid": "提現請求無效",
    "oro.deposit.withdrawMin": "最低提現 {n}",
    "oro.deposit.withdrawNeedAccount": "請先新增提現帳戶",
    "oro.deposit.withdrawPending": "提現處理中",
    "oro.game.login": "登入後開始遊戲",
    "oro.jackpot.congrats": "恭喜 {name} 獲得 {amount}",
    "oro.jackpot.reset": "重置",
    "oro.jackpot.taskLoginLabel": "登入",
    "oro.promo.claimPointsInsufficient": "積分不足，無法領取",
    "oro.ranking.betRemain": "剩餘投注",
    "oro.ranking.board.daily": "日榜",
    "oro.ranking.board.monthly": "月榜",
    "oro.ranking.board.weekly": "週榜",
    "oro.ranking.boardPoints": "榜單積分",
    "oro.ranking.boostDaily": "每日加成",
    "oro.ranking.boostLogin": "登入加成",
    "oro.ranking.boostTotal": "總加成",
    "oro.ranking.boostVip": "VIP 加成",
    "oro.ranking.claim": "領取",
    "oro.ranking.claimFail": "領取失敗",
    "oro.ranking.claimFailTitle": "領取未成功",
    "oro.ranking.claimSuccess": "領取成功",
    "oro.ranking.claimed": "已領取",
    "oro.ranking.col.points": "積分",
    "oro.ranking.col.rank": "名次",
    "oro.ranking.col.reward": "獎勵",
    "oro.ranking.col.user": "使用者",
    "oro.ranking.consolation": "安慰獎",
    "oro.ranking.dayPoints": "今日積分",
    "oro.ranking.done": "已完成",
    "oro.ranking.empty": "暫無資料",
    "oro.ranking.jumpMe": "跳到我的排名",
    "oro.ranking.meCut": "前 {n}",
    "oro.ranking.meGap": "距離上榜",
    "oro.ranking.meListed": "已上榜",
    "oro.ranking.meMin": "門檻 {n}",
    "oro.ranking.meNeed": "還需 {n}",
    "oro.ranking.meNext": "距上一名 {n} 分",
    "oro.ranking.meRank": "我的排名",
    "oro.ranking.meScore": "我的積分",
    "oro.ranking.meStatus": "上榜狀態",
    "oro.ranking.meUnlisted": "未上榜",
    "oro.ranking.meUnreached": "未達門檻",
    "oro.ranking.pageMeta": "共 {total} 名 · {pages} 頁",
    "oro.ranking.entryBar": "上榜進度",
    "oro.ranking.goBet": "去投注",
    "oro.ranking.monthPoints": "本月積分",
    "oro.ranking.overCut": "未進入前 {n}",
    "oro.ranking.pointsCredited": "積分已到帳",
    "oro.ranking.prizeFirst": "第 1 名",
    "oro.ranking.prizeRank": "第 {from}-{to} 名",
    "oro.ranking.redeem": "兌換",
    "oro.ranking.redeemFail": "兌換失敗",
    "oro.ranking.redeemLimit": "已達兌換上限",
    "oro.ranking.redeemSure": "確認將 {from} 兌換為 {to}？",
    "oro.ranking.rulesBetBody": "每投注 {bet} 獲得 {points} 積分",
    "oro.ranking.rulesBetTitle": "投注積分",
    "oro.ranking.rulesClaimAfter": "結算 {hours} 小時後可領取",
    "oro.ranking.rulesDailyBody": "每日加成隨當日活躍累積",
    "oro.ranking.rulesDailyClose": "日榜於當天結束時結算",
    "oro.ranking.rulesDailyTitle": "每日加成說明",
    "oro.ranking.rulesExample": "示例：投注、登入並提升 VIP 可獲得更多積分。",
    "oro.ranking.rulesFormula": "積分 = 基礎分 ×（1 + 加成）",
    "oro.ranking.rulesFormulaTitle": "計算公式",
    "oro.ranking.rulesFreeBody": "{stars} 星星可兌 {points} 積分，每日最多 {cap} 次",
    "oro.ranking.rulesFreeTitle": "星星兌換",
    "oro.ranking.rulesLoginBody": "連續登入每天 +{step}%，中斷 -{miss}%，上限 {max}%",
    "oro.ranking.rulesLoginTitle": "登入加成說明",
    "oro.ranking.rulesMinHit": "達到最低要求即可上榜",
    "oro.ranking.rulesMinMiss": "未達最低要求不上榜",
    "oro.ranking.rulesMinNeed": "上榜需達到最低積分",
    "oro.ranking.rulesMinTitle": "最低上榜分",
    "oro.ranking.rulesMonthlyClose": "月榜於月末結算",
    "oro.ranking.rulesRewardTime": "發獎時間",
    "oro.ranking.rulesTab.point": "積分規則",
    "oro.ranking.rulesTab.rank": "榜單規則",
    "oro.ranking.rulesTime": "結算時間",
    "oro.ranking.rulesTitle": "活動規則",
    "oro.ranking.rulesTypes": "榜單類型",
    "oro.ranking.rulesVipBody": "VIP 加成最高 {max}%",
    "oro.ranking.rulesVipTitle": "VIP 加成說明",
    "oro.ranking.rulesWeeklyClose": "週榜於週日結算",
    "oro.ranking.rulesWhat": "透過投注、登入和兌換獲得積分並提升名次。",
    "oro.ranking.sectionEarn": "如何獲得積分",
    "oro.ranking.sectionMine": "我的排名",
    "oro.ranking.stars": "星星",
    "oro.ranking.tab.panel": "面板",
    "oro.ranking.tab.premio": "獎勵",
    "oro.ranking.tab.rank": "排行",
    "oro.ranking.timeLeft": "剩餘時間",
    "oro.ranking.title": "排行榜",
    "oro.ranking.unavailable": "排行榜暫不可用",
    "oro.ranking.weekPoints": "本週積分",
    "oro.rec.betAmount": "投注額",
    "oro.rec.loadError": "紀錄載入失敗",
    "oro.rec.loading": "正在載入紀錄…",
    "oro.rec.retry": "重試",
    "oro.rec.winAmount": "贏額",
    "oro.sec.loginChange": "修改",
    "oro.sec.loginConfirm": "確認登入密碼",
    "oro.sec.loginHint": "7 到 16 個字元",
    "oro.sec.loginInvalid": "登入密碼不正確",
    "oro.sec.loginNew": "新登入密碼",
    "oro.sec.loginOld": "原登入密碼",
    "oro.sec.loginRelogin": "密碼已更新，請重新登入。",
    "oro.sec.mailChange": "修改",
    "oro.sec.mailEmail": "信箱",
    "oro.sec.mailHint": "請輸入有效信箱",
    "oro.sec.mailInvalid": "信箱無效或不可用",
    "oro.sec.mailLoginPwd": "登入密碼",
    "oro.sec.codeHint": "請輸入6位驗證碼",
    "oro.sec.codeInvalid": "驗證碼錯誤或已過期",
    "oro.sec.codeLabel": "驗證碼",
    "oro.sec.mailTaken": "此信箱已被使用",
    "oro.sec.phoneDesc": "綁定手機號以用於登入和安全驗證。",
    "oro.sec.phoneHint": "請輸入10位手機號",
    "oro.sec.phoneLabel": "手機號",
    "oro.sec.phoneSame": "此手機號已是目前綁定",
    "oro.sec.phoneTaken": "該手機號已被使用",
    "oro.sec.phoneTitle": "手機號",
    "oro.sec.rateLimited": "操作太頻繁，請稍後再試",
    "oro.sec.sendCode": "取得驗證碼",
    "oro.sec.sendFailed": "驗證碼發送失敗",
    "oro.sec.payChange": "修改",
    "oro.sec.payConfirm": "確認支付密碼",
    "oro.sec.payDesc": "提現前請設定6位數字支付密碼。",
    "oro.sec.payHint": "請輸入6位數字",
    "oro.sec.payInvalid": "支付密碼不正確",
    "oro.sec.payMismatch": "兩次密碼不一致",
    "oro.sec.payNew": "新支付密碼",
    "oro.sec.payOld": "原支付密碼",
    "oro.sec.paySet": "設定",
    "oro.sec.payTitle": "設定支付密碼。",
    "oro.team.calcRatePct": "比例 %",
    "oro.team.howReferralNotes": "推薦說明",
    "oro.team.ruleRebate": "返利按團隊等級計算。",
    "oro.team.ruleSize": "團隊人數影響等級。",
    "oro.team.ruleVolume": "團隊流水影響佣金。",
  },
};
